import React from 'react';

export function EmailFooter(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.97616 1.4502H9.02387C9.70371 1.4502 10.2474 1.45019 10.6868 1.48609C11.1377 1.52293 11.5268 1.6003 11.8847 1.78263C12.4586 2.07504 12.9252 2.54164 13.2176 3.11553C13.3999 3.47338 13.4773 3.86253 13.5141 4.31342C13.55 4.75277 13.55 5.29652 13.55 5.97637V8.02403C13.55 8.70388 13.55 9.24763 13.5141 9.68698C13.4773 10.1379 13.3999 10.527 13.2176 10.8849C12.9252 11.4588 12.4586 11.9254 11.8847 12.2178C11.5268 12.4001 11.1377 12.4775 10.6868 12.5143C10.2474 12.5502 9.70369 12.5502 9.02384 12.5502H4.97618C4.29633 12.5502 3.75258 12.5502 3.31323 12.5143C2.86234 12.4775 2.47319 12.4001 2.11534 12.2178C1.54145 11.9254 1.07486 11.4588 0.782443 10.8849C0.60011 10.527 0.522739 10.1379 0.4859 9.68698C0.450004 9.24764 0.450007 8.70389 0.450012 8.02405V5.97635C0.450007 5.29651 0.450004 4.75276 0.4859 4.31342C0.522739 3.86253 0.60011 3.47338 0.782443 3.11553C1.07486 2.54164 1.54145 2.07504 2.11534 1.78263C2.47319 1.6003 2.86234 1.52293 3.31323 1.48609C3.75258 1.45019 4.29632 1.4502 4.97616 1.4502ZM3.4028 2.58243C3.01994 2.61372 2.79166 2.67259 2.61473 2.76274C2.24782 2.94969 1.9495 3.248 1.76255 3.61492C1.6724 3.79185 1.61353 4.02013 1.58225 4.40299C1.55044 4.79228 1.55001 5.29106 1.55001 6.0002V8.0002C1.55001 8.70934 1.55044 9.20812 1.58225 9.59741C1.61353 9.98028 1.6724 10.2086 1.76255 10.3855C1.9495 10.7524 2.24782 11.0507 2.61473 11.2377C2.79166 11.3278 3.01994 11.3867 3.4028 11.418C3.79209 11.4498 4.29087 11.4502 5.00001 11.4502H9.00001C9.70915 11.4502 10.2079 11.4498 10.5972 11.418C10.9801 11.3867 11.2084 11.3278 11.3853 11.2377C11.7522 11.0507 12.0505 10.7524 12.2375 10.3855C12.3276 10.2086 12.3865 9.98028 12.4178 9.59741C12.4496 9.20812 12.45 8.70934 12.45 8.0002V6.0002C12.45 5.29106 12.4496 4.79228 12.4178 4.40299C12.3865 4.02013 12.3276 3.79185 12.2375 3.61492C12.0505 3.248 11.7522 2.94969 11.3853 2.76274C11.2084 2.67259 10.9801 2.61372 10.5972 2.58243C10.2079 2.55063 9.70915 2.5502 9.00001 2.5502H5.00001C4.29087 2.5502 3.79209 2.55063 3.4028 2.58243Z"
        fill="currentColor"
      />
      <mask id="path-2-inside-1_1096_53062" fill="white">
        <rect x="6" y="9" width="5" height="1.1" rx="0.5" />
      </mask>
      <rect
        x="6"
        y="9"
        width="5"
        height="1.1"
        rx="0.5"
        stroke="currentColor"
        strokeWidth="1.1"
        mask="url(#path-2-inside-1_1096_53062)"
      />
      <mask id="path-3-inside-2_1096_53062" fill="white">
        <rect x="3" y="9" width="2" height="1.1" rx="0.5" />
      </mask>
      <rect
        x="3"
        y="9"
        width="2"
        height="1.1"
        rx="0.5"
        stroke="currentColor"
        strokeWidth="1.1"
        mask="url(#path-3-inside-2_1096_53062)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.19984 0.450195C4.5036 0.450195 4.74984 0.696438 4.74984 1.00019V2.75019C4.74984 3.05395 4.5036 3.30019 4.19984 3.30019C3.89608 3.30019 3.64984 3.05395 3.64984 2.75019V1.00019C3.64984 0.696438 3.89608 0.450195 4.19984 0.450195Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.80018 0.450195C10.1039 0.450195 10.3502 0.696438 10.3502 1.00019V2.75019C10.3502 3.05395 10.1039 3.30019 9.80018 3.30019C9.49643 3.30019 9.25018 3.05395 9.25018 2.75019V1.00019C9.25018 0.696438 9.49643 0.450195 9.80018 0.450195Z"
        fill="currentColor"
      />
    </svg>
  );
}
